'use strict';
/**
 * @name optional - preappend string, when it is not empty
 * @param {string} prefix
 * @param {string} str
 * @returns string
 */

module.exports = function optional() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var str = arguments[1];
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!str) return '';
  return '' + prefix + str + suffix;
};